import { DynamicStandaloneRow } from '@/components/Row';
import { LabradorComponent } from '@/types/component';
import cn from '@/utils/cn';
import { getChildrenCount } from '@/utils/getChildrenCount';
import { getViewportVisibilityClass } from '@/utils/index';
import { withBackgroundColor, withTextAlign } from '@/utils/withBackgroundColor';
import withDebugMetadata from '@/utils/withDebugMetadata';
import { withColumnsSystem } from '@/utils/withGridSystem';
import { renderContentComponent } from 'modules/dynamic/components';
import { Fragment } from 'react';

const LabradorRow: LabradorComponent = ({ type, data, meta, descendants }) => {
  if (!getChildrenCount(descendants)) {
    return null;
  }

  const backgroundColor = withBackgroundColor(meta.backgroundColor, true);
  const columns = withColumnsSystem(meta.width);
  const viewportVisibilityClass = getViewportVisibilityClass({
    viewportVisibility: meta.viewportVisibility,
    hideViewport: meta.hideViewport,
    display: 'grid',
  });

  const content = descendants.map((child, index) => {
    return <Fragment key={index}>{renderContentComponent(child)}</Fragment>;
  });

  const contentIndex = meta.contentIndex;
  const textAlign = withTextAlign(meta.textAlignRowTitle);

  return (
    <DynamicStandaloneRow
      headline={data.title}
      content={content}
      button={data.rowButton}
      options={{
        className: cn(backgroundColor, columns, viewportVisibilityClass),
        size: backgroundColor ? 'alternative' : 'default',
        $headline: { className: cn(textAlign) },
      }}
      data-content-index={contentIndex}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorRow;
